import { B2ListGroup } from "@hdb/biome-2";
import { FC, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import HasPermission from "../../../../../../core/guards/has-permission";
import { useAppSelector } from "../../../../../../store/hooks";
import { getAssetchildren } from "../../../../../../store/slices/asset.slice";
import "./asset-action-sidebar.scss";

interface AssetActionSideBarComponentProps {
  moduleName: any;
  isAccordion: boolean;
}

const AssetActionSideBarComponent: FC<AssetActionSideBarComponentProps> = ({
  moduleName,
  isAccordion,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const modules: any = useAppSelector((state) => state.navbar.modules);
  const [menuArray, setMenuArray] = useState([] as any);
  const [activeRoute, setActiveRoute] = useState<string>("");

  const navigateToUrl = (url: any) => {
    navigate(url);
  };

  useEffect(() => {
    setActiveRoute(location.pathname);
  }, [location]);

  // useEffect(() => {
  //   if (!modules.length) return;

  //   getModuleName(modules, moduleName);
  // }, [modules, moduleName]);

  useEffect(() => {
    if (!modules.length) return;

    getModuleName(modules, moduleName);
  }, [modules, moduleName]);

  useEffect(() => {
    if (!modules.length) {
      dispatch(getAssetchildren());
    }
  }, []);

  const getModuleName = (modules: any, moduleName: string) => {
    for (let menu of modules) {
      if (menu.name === moduleName) {
        setMenuArray(menu.childMenuList);
        return;
      }

      if (menu.childMenuList) {
        getModuleName(menu.childMenuList, moduleName);
      }
    }
  };

  const excludeProfile = (menu: any) => {
    const excludeProfileArray = [
      "luminance profile",
      "daylight harvesting",
      "rain profile",
      "Dimming Profile",
    ].map((item) => item.toLowerCase());
    const isProfile = excludeProfileArray.includes(menu.name.toLowerCase());

    return isProfile;
  };

  return (
    <div>
      {isAccordion ? (
        // <div>hello world</div>
        <></>
      ) : (
        // this part of the program is not being used anywhere, that's why not refactored to BIOME components
        // <Accordion className="sidebar shadow-lg">
        //   {menuArray.length
        //     ? menuArray.map((menu: any, i) => (
        //         <Accordion.Item key={i} eventKey={`${i}`}>
        //           <Accordion.Header
        //             className={`${
        //               activeRoute.split("/")[
        //                 activeRoute.split("/").length - 1
        //               ] === menu.url.split("/")[menu.url.split("/").length - 1]
        //                 ? "active"
        //                 : ""
        //             } hide-expand-icon`}
        //           >
        //             {menu.name}
        //           </Accordion.Header>
        //           <Accordion.Body>
        //             {menu.childMenuList.map((childMenu: any, index: number) => (
        //               <HasPermission
        //                 moduleName={childMenu.name}
        //                 isRoute={false}
        //                 functionId={ROOT_MODULE_ACTION}
        //                 key={i}
        //               >
        //                 <div
        //                   onClick={() => navigateToUrl(childMenu.url)}
        //                   className="childmenu"
        //                   key={index}
        //                 >
        //                   {childMenu.name}
        //                 </div>
        //               </HasPermission>
        //             ))}
        //           </Accordion.Body>
        //         </Accordion.Item>
        //       ))
        //     : null}
        // </Accordion>
        <B2ListGroup>
          {menuArray.length
            ? menuArray.map((menu: any, i: any) =>
              excludeProfile(menu) ? null : (
                <HasPermission
                  moduleName={menu.name}
                  isRoute={false}
                  actionName={"View-" + menu.name}
                  key={i}
                >
                  <B2ListGroup.Item
                    onClick={() => navigateToUrl(menu.url)}
                    className={`cursor-pointer ${activeRoute.split("/")[
                        activeRoute.split("/").length - 1
                      ] ===
                        menu.url.split("/")[menu.url.split("/").length - 1]
                        ? "active active-without-child"
                        : ""
                      }`}
                  >
                    <span style={{ color: "black" }}>{menu.name}</span>
                  </B2ListGroup.Item>
                </HasPermission>
              )
            )
            : null}
        </B2ListGroup>
      )}
    </div>
  );
};

export default AssetActionSideBarComponent;
